
import { Options, Vue } from "vue-class-component";
import { Cl_common } from "@/functions/Cl_common";
import { Cl_message } from "@/functions/Cl_message";
import { DtoMessagesGetReqImple } from "mediadept-common/src/common/dto/DtoMessagesGetReqImple";
import { DtoMessagesGetResImple } from "mediadept-common/src/common/dto/DtoMessagesGetResImple";
import { DtoMessagesPutReq } from "mediadept-common/src/common/dto/abst/DtoMessagesPutReq";
import { DtoMessagesPutRes } from "mediadept-common/src/common/dto/abst/DtoMessagesPutRes";
import { DtoMessagesPostReq } from "mediadept-common/src/common/dto/abst/DtoMessagesPostReq";
import { DtoMessagesPostRes } from "mediadept-common/src/common/dto/abst/DtoMessagesPostRes";
import Mo_modal_alert from "@/components/molecules/Mo_modal_alert.vue";

// バリデーション
import * as Yup from "yup";

@Options({
  components: {
    Mo_modal_alert,
  },
})
export default class Messageedit extends Vue {
  //----------------------
  //バリデーション
  //----------------------
  //スキーマ宣言
  schemaAdd = Yup.object().shape({
    startDate: Yup.string().required("開始日を選択してください。"),
    endDate: Yup.string().required("終了日を選択してください。"),
    messageCont: Yup.string().required("メッセージを入力してください。"),
  });
  schemaUpd = Yup.object().shape({
    startDate: Yup.string().required("開始日を選択してください。"),
    endDate: Yup.string().required("終了日を選択してください。"),
    messageCont: Yup.string().required("メッセージを入力してください。"),
  });

  //エラー格納用
  errors: Yup.ValidationError | null = null;

  //----------------------
  //DOM連携用プロパティ
  //----------------------
  delegate = new DtoMessagesGetResImple();
  btnDisable = false;
  isEditMode = true;
  start: string | undefined = "";
  end: string | undefined = "";

  //----------------------
  //モーダル用プロパティ
  //----------------------
  message4ModalSuccess = "";
  message4ModalDelConf = "";
  message4ModalErrorConf = "";

  //----------------------
  //制御用メソッド
  //----------------------
  async mounted() {
    await this.get();
  }

  //----------------------
  //基本操作用メソッド
  //----------------------}
  /**
   * データを読み込む
   */
  async get() {
    //ボタン無効＋ローダー表示
    //-----------------
    this.btnDisable = true;
    const panel = document.getElementsByClassName("panel-container");
    Array.from(panel).map((element: Element) => {
      element.classList.add("enable-loader");
    });

    try {
      //処理
      //-----------------
      Cl_common.logger("処理実行");

      //パラメータにIDが指定されていなければ、新規追加モードでデータを読み込まない
      //-------
      let id = Cl_common.getParam("id");
      if (id == "") {
        //新規追加
        this.isEditMode = false;
        //初期値設定
        //this.delegate.c_client_company_type = 1;
        //this.delegate.c_client_flag_company_signage_posi = 1;
        return;
      } else {
        //編集
        this.isEditMode = true;
      }

      //準備
      //-------
      let dto = new DtoMessagesGetReqImple();

      dto.c_message_id = Number(id);

      //API実行
      //-------
      this.delegate = await Cl_message.get(dto);
      //レスポンス処理
      //-------
      //IDがnullなら一覧へ遷移
      if (this.delegate.c_message_id == null) {
        this.$router.push("/messagelist");
      }
      this.start = this.delegate.c_message_start?.toString().split("T")[0];
      this.end = this.delegate.c_message_end?.toString().split("T")[0];
    } catch (error) {
      //モーダルのメッセージを設定
      this.message4ModalErrorConf = "エラーが発生しました";
      //モーダル表示
      const modal: any = this.$refs.Mo_modal_errorConf;
      modal.showModal();

      Cl_common.logger(error);
    } finally {
      //ボタン無効解除＋ローダー非表示
      //-----------------
      this.btnDisable = false;
      Array.from(panel).map((element: Element) => {
        element.classList.remove("enable-loader");
      });
    }
  }

  /**
   * データを更新する
   */
  async upd(isDel: boolean) {
    //ボタン無効＋ローダー表示
    //-----------------
    this.btnDisable = true;
    const panel = document.getElementsByClassName("panel-container");
    Array.from(panel).map((element: Element) => {
      element.classList.add("enable-loader");
    });

    try {
      //処理
      //-----------------
      Cl_common.logger("処理実行");

      //準備
      //-------
      let dto = new DtoMessagesPutReq();
      if (isDel) {
        //削除処理：削除フラグを立てる。
        dto.c_message_id = this.delegate.c_message_id;
        dto.c_message_flag_del = 1;
      } else {
        //バリデーション
        //-----------------
        this.errors = null;

        this.schemaUpd.validateSync({
          startDate: this.start,
          endDate: this.end,
          messageCont: this.delegate.c_message_cont,
        });

        //更新処理：delegateからdtoにデータ投入。
        dto = Object.assign(new DtoMessagesPutReq(), this.delegate);
        if (this.start != undefined) {
          dto.c_message_start = new Date(this.start);
        }
        if (this.end != undefined) {
          dto.c_message_end = new Date(this.end!);
        }
      }

      //API実行
      //-------
      await Cl_message.put(dto);
      //レスポンスの処理
      //-------

      //更新処理：
      //モーダルのメッセージを設定
      if (isDel) {
        //削除処理：
        this.message4ModalSuccess = "正常に削除されました";
      } else {
        //更新処理：
        this.message4ModalSuccess = "正常に変更されました";
      }

      //モーダルを表示
      const modal: any = this.$refs.Mo_modal_success;
      modal.showModal();
    } catch (error) {
      if (error instanceof Yup.ValidationError) {
        //バリデーション
        //---------------
        //モーダルのメッセージを設定
        this.message4ModalErrorConf = error.errors[0];
        this.errors = error;
      } else {
        //それ以外
        //---------------
        //モーダルのメッセージを設定
        this.message4ModalErrorConf = "エラーが発生しました";
      }
      //モーダル表示
      const modal: any = this.$refs.Mo_modal_errorConf;
      modal.showModal();

      Cl_common.logger(error);
    } finally {
      //ボタン無効解除＋ローダー非表示
      //-----------------
      this.btnDisable = false;
      Array.from(panel).map((element: Element) => {
        element.classList.remove("enable-loader");
      });
    }
  }

  /**
   * データを新たに登録する
   */
  async add() {
    //ボタン無効＋ローダー表示
    //-----------------
    this.btnDisable = true;
    const panel = document.getElementsByClassName("panel-container");
    Array.from(panel).map((element: Element) => {
      element.classList.add("enable-loader");
    });

    try {
      //処理
      //-----------------
      Cl_common.logger("処理実行");

      //バリデーション
      //-----------------
      this.errors = null;
      this.schemaAdd.validateSync({
        // #3960
        startDate: this.start,
        endDate: this.end,
        messageCont: this.delegate.c_message_cont,
      });

      //準備
      //-------
      let dto = Object.assign(new DtoMessagesPostReq(), this.delegate);
      dto.c_message_flag_del = 0;
      if (this.start != undefined) {
        dto.c_message_start = new Date(this.start);
      }
      if (this.end != undefined) {
        dto.c_message_end = new Date(this.end!);
      }

      //API実行
      //-------
      const res = await Cl_message.post(dto);

      //レスポンスの処理
      //-------
      //編集画面のURL作成
      this.$router.push({
        path: "/messageedit",
        query: { id: res.c_message_id },
      });

      this.start = res.c_message_start?.toString().split("T")[0];
      this.end = res.c_message_end?.toString().split("T")[0];

      //モーダルのメッセージを設定
      this.message4ModalSuccess = "データを更新しました。";

      //モーダルを表示
      const modal: any = this.$refs.Mo_modal_success;
      modal.showModal();
    } catch (error) {
      if (error instanceof Yup.ValidationError) {
        //バリデーション
        //---------------
        //モーダルのメッセージを設定
        this.message4ModalErrorConf = error.errors[0];
        this.errors = error;
      } else {
        //それ以外
        //---------------
        //モーダルのメッセージを設定
        this.message4ModalErrorConf = "エラーが発生しました";
      }
      //モーダル表示
      const modal: any = this.$refs.Mo_modal_errorConf;
      modal.showModal();

      Cl_common.logger(error);
    } finally {
      //ボタン無効解除＋ローダー非表示
      //-----------------
      this.btnDisable = false;
      Array.from(panel).map((element: Element) => {
        element.classList.remove("enable-loader");
      });
    }
  }

  /**
   * データを削除する
   */
  async del() {
    //削除フラグのあるテーブルなので更新処理。
    this.closeModal4deleteConf();
    this.upd(true);
  }

  /**
   * データを削除する
   */
  async delConf() {
    //モーダルのメッセージを設定
    this.message4ModalDelConf = "削除してもよろしいでしょうか。";

    //モーダルを表示
    const modal: any = this.$refs.Mo_modal_deleteConf;
    modal.showModal();
  }

  //----------------------
  //モーダル用メソッド
  //----------------------
  async closeModal4deleteConf(): Promise<void> {
    const modal: any = this.$refs.Mo_modal_deleteConf;
    modal.closeModal();
  }
  async closeModal4ErrorConf(): Promise<void> {
    const modal: any = this.$refs.Mo_modal_errorConf;
    modal.closeModal();
  }
}
